import { NO_CATERING_ACCESS } from '../../services/cateringAccessPermissions';
import { RESET_REPORTS_DATA } from '../globalActions';
import { CACC, type CateringAccessState } from './cateringAccessTypes';
import type { CateringAccessAction } from './cateringAccessActions';

export const initialCateringAccessState: CateringAccessState = { ...NO_CATERING_ACCESS, status: 'idle' };

type ResetAction = { type: typeof RESET_REPORTS_DATA };

export function cateringAccessReducer(
  state: CateringAccessState = initialCateringAccessState,
  action: CateringAccessAction | ResetAction,
): CateringAccessState {
  if (action.type === CACC.LOAD_REQUEST) {
    // A re-read keeps the last answer on screen until the new one arrives.
    return state.status === 'ready' ? state : { ...state, status: 'loading' };
  }
  if (action.type === CACC.LOAD_DONE && 'payload' in action) {
    return { ...action.payload, status: 'ready' };
  }
  if (action.type === RESET_REPORTS_DATA) {
    // Logout: the next employee's permissions are read from scratch, never shown from the previous session.
    return initialCateringAccessState;
  }
  return state;
}
